import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import PropTypes from "prop-types";
import ActionButton from "../../../Components/Buttons/ActionButton";
import { clearFilters } from "../Redux/FiltersReducer";
import WhatsNew from "../../../Components/OnBoarding/WhatsNew";
import Fade from "@mui/material/Fade";

const BookingsLogsTitleAction = (props) => {
    const dispatch = useDispatch();
    const routeParams = useParams();
    const navigate = useNavigate();

    const ONBOARDING_TAG = 'bookings_log';
    const onboardingStatus = useSelector(state => state.module['VISITORS'].common.onboarding[ONBOARDING_TAG]);

    const {dateRangeStart, dateRangeEnd, searchTerm, multiFilter, category, amenity, status}
        = useSelector(state => state.module['BOOKINGS'].filters);

    const anyFilterIsSet = () => {
        return (!!dateRangeStart || !!dateRangeEnd || !!searchTerm
            || (category && category !== 'all')
            || !!amenity
            || !!multiFilter.length
            || status !== 'all');
    }

    if (['active', 'ignored'].includes(onboardingStatus)) {
        return <WhatsNew key={3} tag={ONBOARDING_TAG}/>;
    }

    return (
        <Fade in={anyFilterIsSet()}>
            <div className="display-inline">
                <ActionButton
                    title="Clear Filters"
                    onClick={(e) => {
                        dispatch(clearFilters());
                        navigate(`/bookings/logs/${routeParams.view}/${routeParams.scope}`);
                    }}
                    className="clear secondary inline-with-page-title"
                    style={{marginTop: '1rem', marginLeft: '1rem'}}
                />
            </div>
        </Fade>
    );
}

BookingsLogsTitleAction.propTypes = {
   
}

BookingsLogsTitleAction.defaultProps = {
    
}

export default BookingsLogsTitleAction;
